import { useRef } from "react";

import { crest, type Frame, kids, type Layer, type LayerProps,N, STEM_FLOOR, STEM_TOP, usePainter } from "./core";

/** 100% tracked: a point snake on stems, a wave running head to tail. */
export const Snake: Layer = Object.assign(
  ({ register }: LayerProps) => {
    const group = useRef<SVGGElement>(null);

    usePainter(register, () => {
      const stems = kids(group, "line");
      const floor = STEM_FLOOR.toFixed(1);
      return (pts, a, f) => {
        stems.forEach((stem, i) => {
          const x = pts[i].x.toFixed(1);
          stem.setAttribute("x1", x);
          stem.setAttribute("y1", pts[i].y.toFixed(1));
          stem.setAttribute("x2", x);
          stem.setAttribute("y2", floor);
          const lit = 0.14 + crest(i / (N - 1), f.wave) * 0.5;
          stem.setAttribute("opacity", (lit * a).toFixed(2));
        });
      };
    });

    return (
      <>
        <defs>
          <linearGradient id="field-stem" x1="0" y1={STEM_TOP} x2="0" y2={STEM_FLOOR} gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="var(--fc)" stopOpacity="0.55" />
            <stop offset="1" stopColor="var(--fc)" stopOpacity="0" />
          </linearGradient>
        </defs>
        <g ref={group}>
          {Array.from({ length: N }, (_, i) => (
            <line key={i} stroke="url(#field-stem)" strokeWidth={1} opacity={0} />
          ))}
        </g>
      </>
    );
  },
  {
    shape: (u: number) => ({
      x: 120 + u * 960,
      y: 168 + Math.sin(u * Math.PI * 2.5) * 62,
    }),
    light: (u: number, _x: number, _y: number, f: Frame) => crest(u, f.wave) * 0.95,
  },
);
